<template>
  <div id="viewmap">
    <Carousel v-model="value1">
      <CarouselItem>
        <div class="demo-carousel" id="view1">
          <h1 class="title">储罐实时监控平台</h1>
          <Row class="statstcTotal">
            <Col span="3"></Col>
            <Col span="3">
              <Card :bordered="false">
                <span>今日用气量</span>
                <h4 style="color: #8045c8">{{obj.todayCurrentDataNm3}}Nm3</h4>
              </Card>
            </Col>
            <Col span="2"></Col>
            <Col span="3">
              <Card :bordered="false">
                <span>昨日总用气量</span>
                <h4 style="color: #25d2e8">{{obj.yesterdayDataNm3}}Nm3</h4>
              </Card>
            </Col>
            <Col span="2"></Col>
            <Col span="3">
              <Card :bordered="false">
                <span>当前同比昨日</span>
                <h4 style="color: #ec4675">
                  {{(obj.todayCurrentDataNm3- obj.yesterdayCurrentDataNm3).toFixed(2)}}Nm3
                  <Icon
                    type="md-arrow-round-up"
                    v-show="obj.todayCurrentDataNm3- obj.yesterdayCurrentDataNm3>0"
                  />
                  <Icon
                    type="md-arrow-round-down"
                    v-show="obj.todayCurrentDataNm3- obj.yesterdayCurrentDataNm3<0"
                  />
                </h4>
              </Card>
            </Col>
            <Col span="2"></Col>
            <Col span="3">
              <Card :bordered="false">
                <span>站点在线率</span>
                <h4 style="color: #25d2e8">{{obj.siteOnlineRate*100}}%</h4>
              </Card>
            </Col>
            <Col span="3"></Col>
          </Row>
          <Row class="fenkuai">
            <Col span="6">
              <Card :bordered="false">
                <div class="line">
                  <h3>大数据统计</h3>
                  <img src="../../assets/line.png" />
                </div>
                <div class="line">
                  <p>
                    <b style="display: inline-block;width: 70%;font-weight: normal">总用量</b>
                    <span style="color: #fff;font-size: 12px">单位：Nm3</span>
                  </p>
                  <div id="lineEchart"></div>
                  <img src="../../assets/line.png" />
                </div>
                <div class="line">
                  <p>数据统计</p>
                  <div id="barEchart"></div>
                  <img src="../../assets/line.png" />
                </div>
                <div class="line">
                  <p>剩余可用时长</p>
                  <ul class="leaveTime">
                    <li v-for="item in listTime">
                      <strong>
                        <i></i>
                        {{item.siteName.substring(0,2)+"**"}}
                      </strong>
                      <b>{{item.haveTime.toString().hlong()}}</b>
                    </li>
                  </ul>
                </div>
              </Card>
            </Col>
            <Col span="12">
              <div style="width:100%;height:100%;">
                <div id="mapBox" class="centerItem"></div>
              </div>
            </Col>
            <Col span="6">
              <Card :bordered="false">
                <div class="line">
                  <h3>天然气用量数据统计</h3>
                  <img src="../../assets/line.png" />
                </div>
                <div class="line">
                  <p>
                    <b style="display: inline-block;width: 70%;font-weight: normal">平均天用量</b>
                    <span style="color: #fff;font-size: 12px">单位：Nm3</span>
                  </p>
                  <div id="barEcharts2"></div>
                  <p class="tips">
                    <span>高峰：{{hight}}</span>
                    <span>低谷：{{low}}</span>
                  </p>
                  <img src="../../assets/line.png" />
                </div>
                <div class="line">
                  <p>站点近7天总用量排行(Nm3)</p>
                  <ul class="leaveTime use">
                    <li v-for="(item,index) in listUse">
                      <strong>
                        <em>{{index+1}}</em>
                        {{item.name.substring(0,2)+'**'}}
                      </strong>
                      <b>{{Number(item.dataNm3).toFixed(2)}}</b>
                    </li>
                  </ul>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </CarouselItem>
      <CarouselItem>
        <div class="demo-carousel car2">
          <img src="../../assets/bg2.png" />
        </div>
      </CarouselItem>
      <CarouselItem>
        <div class="maskDiv"></div>
        <iframe
          src="https://m.znzw.net/realmonitor/monitor"
          frameborder="0"
          id="iframe_add"
          name="iframe_add"
          scrolling=no
          :height="screenHeight"
        ></iframe>
      </CarouselItem>
    </Carousel>
  </div>
</template>

<script>
import {
  statisticCount,
  currentStatisticCount,
  unusedTime,
  siteAllUsedRank,
  massStatistic,
  averageUseMount,
  getMapInfo,
  siteCount
} from "@/api/Map.js";
import echarts from "echarts";
import { showEcharts } from "@/assets/echartsShow.js";
import { countTime, howLong } from "../../common/index";
import chinaData from 'echarts/map/json/china'

export default {
  name: "rm-map",
  data() {
    return {
      normal: [],
      exception: [],
      next: true,
      data1: null,
      data2: null,
      data3: null,
      hight: null,
      low: null,
      value1: 0,
      mapBoxEchart: null,
      obj: {
        todayCurrentDataNm3: null,
        yesterdayCurrentDataNm3: null,
        yesterdayDataNm3: null,
        siteOnlineRate: null
      },

      listTime: [],
      listUse: [],
      screenHeight: document.body.clientHeight  // 获取窗口高度
    };
  },
  created: function() {
    //实例被创建之后执行代码
    String.prototype.hlong = function() {
      return howLong(this);
    };
  },
  mounted() {
    this.getData();
    var ba = document.documentElement.clientHeigh || document.body.clientHeight;
    let iframe = document.getElementById("iframe_add");
    console.log("ba", ba);
    this.setChinaMap();
    this.getMonitorData();
    document.body.addEventListener("click", ev => {
      ev.stopPropagation();
      ev.preventDefault();
      document.getElementsByClassName("ivu-carousel-arrow-hover")[1].click();
      // this.value1 += 1;
      // console.log(this.value1, 852);
    });

    // echart图表自适应
    window.onresize = () => {
      this.mapBoxEchart.resize();
      console.log(11, 998);
      showEcharts("barEchart", 2, this.data1);
      showEcharts("lineEchart", 1, this.data2);
      showEcharts("barEcharts2", 3, this.data3);
    };
    // this.$nextTick(() => {
      // document.getElementById("viewmap").style.height = ba + "px";
      // iframe.style.height = document.body.clientHeight + "px";
    // });
    // 获取窗口高度
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight
        that.screenHeight = window.screenHeight
      })()
    }
  },
  methods: {
    getData() {
      currentStatisticCount(null, res => {
        if (res.data.errcode == 0) {
          let dat = res.data.body;
          //当前数据
          this.obj = { ...dat };
        }
      });
      statisticCount(null, res => {
        if (res.data.errcode == 0) {
          //数据统计
          siteCount(null, ret => {
            if (ret.data.errcode == 0) {
              this.data1 = res.data.body;
              this.data1.siteTotalNum += ret.data.body * 1;
              showEcharts("barEchart", 2, this.data1);
            }
          });
        }
      });
      var query = {
        startTime: countTime(7).split(",")[0] + " 00:00",
        endTime: countTime(0).split(",")[1] + " 23:59"
      };
      massStatistic(query, null, res => {
        if (res.data.errcode == 0) {
          this.data2 = { time: [], value: [] };
          res.data.body.dataList.forEach(item => {
            this.data2.time.push(item.collectTime.substring(5));
            this.data2.value.push(item.totalData);
          });
          showEcharts("lineEchart", 1, this.data2, 5000000);
        }
      });
      siteAllUsedRank(query, null, res => {
        if (res.data.errcode == 0) {
          this.listUse = res.data.body;
        }
      });
      averageUseMount(query, null, res => {
        if (res.data.errcode == 0) {
          this.data3 = { time: [], value: [] };
          res.data.body.dataList.forEach((item, index) => {
            this.data3.time.push(item.collectTime.substring(5));
            this.data3.value.push(item.totalData);
            if (index == 0) {
              this.hight = item.totalData;
              this.low = item.totalData;
            } else {
              if (parseFloat(this.hight) <= parseFloat(item.totalData)) {
                this.hight = item.totalData;
              } else if (parseFloat(this.low) > parseFloat(item.totalData)) {
                this.low = item.totalData;
              }
            }
          });
          showEcharts("barEcharts2", 3, this.data3, 5000000);
        }
      });
      unusedTime({"pageNumber": 4}, res => {
        if (res.data.errcode == 0) {
          this.listTime = res.data.body;
        }
      });
    },
    //获取监控数据
    getMonitorData() {
      getMapInfo(null, res => {
        if (res.data.errcode == 0) {
          res.data.body.map(item => {
            if (item.lonlat) {
              if (item.isAlarm == 0) {
                this.normal.push(item);
              } else {
                this.exception.push(item);
              }
            }
          });
          this.setChinaMap();
        }
      });
    },
    // 中国地图初始化
    setChinaMap() {
      this.mapBoxEchart = echarts.init(document.getElementById("mapBox"));
      echarts.registerMap('china', chinaData);

      var option = {
        legend: {
          orient: "horizontal",
          x: "left",
          data: ["正常", "异常"],
          textStyle: {
            color: "#fff"
          }
        },
        geo: {
          map: 'china',
          roam: false,
          // aspectScale:1,
          zoom: 1.2, //缩放
          top: '8%',
          label: {
            emphasis: {
              show: true,
              color: "#fff"

            }
          },
          itemStyle: {
            normal: {
              borderColor: "rgba(100,149,237,1)",
              borderWidth: 1,
              areaColor: "rgb(49,31,181)",
              label: {
                show: false,
                textStyle: {
                  color: "rgb(249, 249, 249)"
                }
              }
            },
            emphasis: {
              areaColor: "rgba(62,21,114,.5)",
              label: {
                show: true,
                textStyle: {
                  color: "#fff"
                }
              }
            }
          },
        },
        series: [
          {
            name: '正常',
            type: 'effectScatter',
            coordinateSystem: 'geo',
            data: (() => {
              let d = this.normal.map(item => {
                let coord = item.lonlat.split(",");
                let name = item.siteName;
                let value = item.collectParameterList;
                return {
                  name: name,
                  value: coord
                };
              });
              return d;
            })(),
            symbolSize: 8,
            legendHoverLink:true,       //是否启用图例 hover 时的联动高亮。
            hoverAnimation:true,        //是否开启鼠标 hover 的提示动画效果。
            effectType:"ripple",        //特效类型，目前只支持涟漪特效'ripple'。
            showEffectOn:"render",      //配置何时显示特效。可选：'render' 绘制完成后显示特效。'emphasis' 高亮（hover）的时候显示特效。
            rippleEffect:{              //涟漪特效相关配置。
              period:4,               //动画的时间。
              scale:2.5,              //动画中波纹的最大缩放比例。
              brushType:'stroke',      //波纹的绘制方式，可选 'stroke' 和 'fill'。
            },
            label: {
              normal: {
                show: false,
                formatter: function (param) {
                  return param.data.name;
                },
                color: "rgb(255, 255, 255)",
                position: 'top',
              },
              emphasis: {
                show: true,
                formatter: function (param) {
                  return param.data.name;
                },
                color: "rgb(255, 255, 255)",
                position: 'top',
              },
            },
            itemStyle: {
              normal: {
                color: '#1ddcdd'
              },
              emphasis: {
                // borderColor: '#fff',
                // borderWidth: 1
              }
            },

          },
          {
            name: '异常',
            type: 'effectScatter',
            coordinateSystem: 'geo',
            data: (() => {
              let d = this.exception.map(item => {
                let coord = item.lonlat.split(",");
                let name = item.siteName;
                let value = item.collectParameterList;
                return {
                  name: name,
                  value: coord,
                };
              });
              return d;
            })(),
            symbolSize: 8,
            legendHoverLink:true,       //是否启用图例 hover 时的联动高亮。
            hoverAnimation:true,        //是否开启鼠标 hover 的提示动画效果。
            effectType:"ripple",        //特效类型，目前只支持涟漪特效'ripple'。
            showEffectOn:"render",      //配置何时显示特效。可选：'render' 绘制完成后显示特效。'emphasis' 高亮（hover）的时候显示特效。
            rippleEffect:{              //涟漪特效相关配置。
              period:4,               //动画的时间。
              scale:3,              //动画中波纹的最大缩放比例。
              brushType:'stroke',      //波纹的绘制方式，可选 'stroke' 和 'fill'。
            },
            label: {
              normal: {
                show: false,
                formatter: function (param) {
                  return param.data.name;
                },
                color: "rgb(255, 255, 255)",
                position: 'top',
              },
              emphasis: {
                show: true,
                formatter: function (param) {
                  return param.data.name;
                },
                color: "rgb(255, 255, 255)",
                position: 'top',
              },
            },
            itemStyle: {
              // emphasis: {
              //   borderColor: '#fff',
              //   borderWidth: 1
              // }
            },

          },
        ]
      };

      // 使用制定的配置项和数据显示图表
      this.mapBoxEchart.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
body,
html,
#app {
  height: 100%;
}
#viewmap {
  height: 100%;
  overflow: hidden;
  font-size: 13px;
  color: #fff;
  .title {
    font-size: 20px;
    text-align: center;
    padding-top: 33px;
  }
  .statstcTotal .ivu-card-body {
    padding: 16px 0;
    h4 {
      font-size: 16px;
    }
  }
  .ivu-card {
    background: #0c2962;
  }
  .ivu-col {
    min-height: 10px;
  }
  .statstcTotal {
    margin: 15px auto 15px;
    .ivu-icon {
      font-size: 12px;
    }
    span {
      display: block;
      text-align: center;
    }
    h4 {
      text-align: center;
      font-size: 20px;
      font-weight: normal;
      margin-top: 10px;
    }
  }
  #lineEchart {
    width: 90%;
    height: 250px;
    margin: 0 auto;
  }
  #barEchart {
    width: 90%;
    height: 150px;
    margin: 0 auto;
  }
  #barEcharts2 {
    width: 90%;
    height: 300px;
    margin: 0 auto;
  }
  .line {
    // min-width: 300px;
    h3 {
      color: #00ffff;
      font-size: 18px;
      padding: 0 20px;
    }

    p {
      color: #00ffff;
      font-size: 15px;
      margin: 5px 0;
    }
    .leaveTime {
      li {
        line-height: 25px;
      }
      strong {
        font-size: 13px;
        color: #25d2e8;
        display: inline-block;
        width: 70%;
        font-weight: normal;
      }
      b {
        font-size: 13px;
        color: #25d2e8;
        display: inline-block;
        width: 28%;
        text-align: right;
        font-weight: normal;
      }
      i {
        width: 8px;
        height: 8px;
        display: inline-block;
        background: #25d2e8;
        margin-right: 2px;
      }
      em {
        padding: 2px 5px;
        display: inline-block;
        background: #fff;
        margin-right: 2px;
        border-radius: 50%;
        color: #333;
        font-size: 11px;
      }
    }
    .use {
      li {
        line-height: normal;
        padding-bottom: 10px;
      }
      strong,
      b {
        color: #fff;
      }
      li:nth-of-type(1) {
        strong,
        b {
          color: #1985e9;
        }
        em {
          background: #1985e9;
        }
      }
      li:nth-of-type(2) {
        strong,
        b {
          color: #8a2cd6;
        }
        em {
          background: #8a2cd6;
        }
      }
      li:nth-of-type(3) {
        strong,
        b {
          color: #26e6b9;
        }
        em {
          background: #26e6b9;
        }
      }
    }
    .tips {
      span {
        display: inline-block;
        font-size: 12px;
        margin: 15px auto 5px;
      }
      span + span {
        margin-left: 20px;
      }
    }
  }
  .fenkuai {
    .ivu-card {
      background: #1b1549;
      /*     opacity: 0.7;*/
    }
  }
  .ivu-carousel {
    height: 100%;
    .ivu-carousel-list {
      height: 100%;
    }
    .ivu-carousel-arrow-hover {
      opacity: 0 !important;
    }
  }
  .ivu-carousel-track,
  .ivu-carousel-item {
    height: 100%;
  }

  .maskDiv {
    width: 100%;
    height: 100vh;
    opacity: 0;
    position: absolute;
  }
  #iframe_add {
    width: 100%;
    height: 100vh;
  }
}
#view1 {
  width: 100%;
  height: 100vh;
  background: url("../../assets/bg.png") no-repeat;
  background-size: 100% 100%;
}
.demo-carousel {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
  }
}
.car2 {
  img {
    height: 100vh !important;
  }
}

.ivu-carousel-dots-inside {
  display: none !important;
}
@media screen and(max-width:1366px) {
  #viewmap {
    .title {
      padding-top: 15px;
      padding-left: 10px;
    }
    .line {
      h3 {
        padding: 0px 20px;
      }
      p {
        margin: 0px;
      }
    }
  }
  #viewmap #lineEchart {
    // height: 150px;
    height: 100px;
  }
  #viewmap #barEchart {
    // height: 120px;
    height: 95px;
  }
  #viewmap #barEcharts2 {
    // height: 200px;
    height: 120px;
  }
  .centerItem {
    height: 600px;
    width: 600px;
  }
}

@media screen and(min-width:1366px) {
  .centerItem {
    height: 950px;
    width: 950px;
  }
}
</style>
